define('lib/jquery/jquery.bounds',['require','jquery'],function(require) {

    var jQuery = require('jquery');

    jQuery.fn['bounds'] = function (useOuterDimensions) {
        var bounds = {
            left: Number.POSITIVE_INFINITY,
            top: Number.POSITIVE_INFINITY,
            right: Number.NEGATIVE_INFINITY,
            bottom: Number.NEGATIVE_INFINITY,
            width: 0,
            height: 0
        };

        this.each(function (i,el) {
            var elQ = $(el);
            var off = elQ.offset();
            off.right = off.left + (useOuterDimensions ? $(elQ).outerWidth() : $(elQ).width());
            off.bottom = off.top + (useOuterDimensions ? $(elQ).outerHeight() : $(elQ).height());

            if (off.left < bounds.left)
            bounds.left = off.left;

            if (off.top < bounds.top)
            bounds.top = off.top;

            if (off.right > bounds.right)
            bounds.right = off.right;

            if (off.bottom > bounds.bottom)
            bounds.bottom = off.bottom;
        });

        bounds.width = bounds.right - bounds.left;
        bounds.height = bounds.bottom - bounds.top;
        return bounds;
    };

});

